export const application = 'gwu';
export const apiURL = '/gwu/api';
export const gaId = 'UA-91016801-3';



// WEBPACK FOOTER //
// ./src/config/prod.js